import React from 'react';
import BottomNav from '../components/BottomNav';

const GoldOnline = () => {
  const goldUrl = 'https://ibvgold.co.za/';

  return (
    <div className="page-container">
      <div className="page-wrapper">
        <h1 className="page-title">IBV Gold Online</h1>
        <div className="underline"></div>
        <p className="page-subtitle">Premium Gold Trading & Investment</p>
        
        <div style={{ marginBottom: '1rem', display: 'flex', justifyContent: 'flex-end' }}>
          <button
            onClick={() => window.open(goldUrl, '_blank')}
            style={{
              padding: '0.75rem 1.5rem',
              background: 'var(--gold)',
              border: 'none',
              color: 'black',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '1rem',
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}
          >
            <span>Open in Browser</span>
            <span style={{ fontSize: '1.2rem' }}>↗</span>
          </button>
        </div>

        <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
          <iframe 
            src={goldUrl}
            title="IBV Gold Online"
            style={{
              width: '100%',
              height: '80vh',
              border: 'none',
              borderRadius: '8px'
            }}
          />
        </div>
      </div>
      
      <BottomNav />
    </div>
  );
};

export default GoldOnline;
